import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ReactQueryProvider } from '@/utils/ReactQuery';
import SysadminSPA from './SysadminSPA';
import type { SysadminSPAProps } from './SysadminSPA';

// AIDEV-NOTE: BrowserRouter wrapper for react-rails mounting.
// basename="/sysadmin" so all routes resolve relative to the SPA root.
const SysadminSPAWrapper = (props: SysadminSPAProps) => (
  <ReactQueryProvider>
    <BrowserRouter basename="/sysadmin">
      <SysadminSPA {...props} />
    </BrowserRouter>
  </ReactQueryProvider>
);

export default SysadminSPAWrapper;
